import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    triggersContainer: {
        width: '70%',
        maxWidth: 288,
        minWidth: 240,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        position: 'relative',
    },
    skipButtons: { width: 40, height: 40 },
    skipBack: {
        width: 48,
        height: 48,
        marginRight: 0,
    },
    skipForward: {
        width: 48,
        height: 48,
        marginRight: 0,
    },
    playSVG: {
        width: 36,
        height: 40,
    },
    playButton: {
        width: 36,
        height: 40,
        marginRight: 0,
    },
    pauseSVG: {
        width: 28,
        height: 28,
    },
    pauseButton: {
        width: 28,
        height: 28,
        marginRight: 0,
    },
    loading: {
        width: 64,
        height: 64,
    },
});

export default styles;
